import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M10.9944 0.731232C11.3027 0.422923 11.8026 0.422923 12.1109 0.731232L15.2688 3.88913C15.5771 4.19743 15.5771 4.6973 15.2688 5.00561L13.8533 6.42105L9.57895 2.14667L10.9944 0.731232Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M8.46246 3.26316L0.731232 10.9944C0.583176 11.1424 0.5 11.3433 0.5 11.5526V14.7105C0.5 15.1465 0.853459 15.5 1.28947 15.5H4.44737C4.65675 15.5 4.85756 15.4168 5.00561 15.2688L12.7368 7.53754L8.46246 3.26316Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3
  ]))
}